// extracted by mini-css-extract-plugin
module.exports = {"list":"SectionList_list__3Hysx","section":"SectionList_section__3o-vS text_subtitle__384Zd","sectionLine":"SectionList_sectionLine__2Qx7b"};